export default __webpack_public_path__ + "static/media/ban-mobile-image-12.bd95797e.jpg";